export interface VariantColorConfig {
  gradient: { start: string; middle: string; end: string };
  shadow: string;
}

export type ButtonVariant = 'blue' | 'gold' | 'green' | 'yellow' | 'red' | 'grey' | 'light-grey';

export const variantColors: Record<ButtonVariant, VariantColorConfig> = {
  blue: {
    gradient: { start: '#1A7FD5', middle: '#3B9FE8', end: '#5BB8F0' },
    shadow: '#0D5BA3'
  },
  gold: {
    gradient: { start: '#D4AF37', middle: '#F4D03F', end: '#FFE66D' },
    shadow: '#8B6F0F'
  },
  green: {
    gradient: { start: '#059669', middle: '#10B981', end: '#34D399' },
    shadow: '#064E3B'
  },
  yellow: {
    gradient: { start: '#E88A0C', middle: '#F9A825', end: '#FFC234' },
    shadow: '#B5690A'
  },
  red: {
    gradient: { start: '#DC2626', middle: '#EF4444', end: '#F87171' },
    shadow: '#7F1D1D'
  },
  grey: {
    gradient: { start: '#6B7280', middle: '#9CA3AF', end: '#D1D5DB' },
    shadow: '#374151'
  },
  'light-grey': {
    gradient: { start: '#D1D5DB', middle: '#E5E7EB', end: '#F3F4F6' },
    shadow: '#9CA3AF'
  }
};
